import axios from 'axios';
import authHeader from "@/service/auth-header";

class ProvisionService {

    async getProvisions(companyId) {
        return await axios.get(`/api/provision/${companyId}`,{ headers: authHeader() })
    }

    async getCompanyProvisionsForBookings(companyId) {
        return await axios.get(`/api/provision/bookings/${companyId}`,{ headers: authHeader() })
    }

    async getActiveProvisions(companyId) {
        return await axios.get(`/api/provision/active/${companyId}`,{ headers: authHeader() })
    }

    async searchProvisions(companyId, provisionName) {
        console.log("[ProvisionService][searchProvisions] companyId = ", companyId);
        console.log("[ProvisionService][searchProvisions] provisionName = ", provisionName);
        return await axios.get(`/api/provision/search/${companyId}/${provisionName}`,{ headers: authHeader() })
    }

    async getProvision(provisionId) {
        return await axios.get(`/api/provision/specific/${provisionId}`,{ headers: authHeader() })
    }

    async createProvision(companyId, data) {
        return await axios.post(`/api/provision/${companyId}`, data,{ headers: authHeader() });
    }

    async updateProvision(provisionId, data) {
        return await axios.put(`/api/provision/${provisionId}`, data,{ headers: authHeader() });
    }

    async deleteProvision(provisionId) {
        return await axios.delete(`/api/provision/${provisionId}`,{ headers: authHeader() })
    }
}

export default new ProvisionService();
